import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ListQiwaContractRenewal from "./ListQiwaContractRenewal";
import { getQiwaContractRenewData } from "../../../../../store/Api";
import ListQiwaContractRenewal_OPS from "./ListQiwaContractRenewal";
import nodeinstance from "../../../../../nodeInstance";

export default function QiwaContractRenewal_OPS() {
  const qiwa = useSelector((state) => state.qiwaDataRenew);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  // useEffect(() => {
  //   dispatch(getQiwaContractRenewData(token));
  // }, []);

  
  const [data, setData] = useState();

  const getDataAPI = async () => {
    try {
      const response = await nodeinstance.get(
        `/qiwaContract/getQiwaDataGR/${"RENEWOPS"}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setData(response.data);
      }
    } catch (error) {
      console.log("error to be seen here in console", error);
    }
  };

  useEffect(() => {
    getDataAPI();
  }, []);

  const updateData = () => {
    // dispatch(getQiwaContractRenewData(token));
    getDataAPI()
  };

  return (
    <>
      <div className={`p-2  sm:p-5 `}>
        <ListQiwaContractRenewal_OPS
          list={data}
          loading={loading}
          titles={[
            "S.NO.",
            "EMPLOYEE ID",
            "EMPLOYEE NAME",
            "RELIGION",
            "NATIONALITY",
            "CURRENT SPONSOR",
            "CLIENT",
            "UPLOAD INSTANCE",
            "STATUS",
            "ACTION",
          ]}
          token={token}
          updateData={updateData}
        />
      </div>
    </>
  );
}
